import { toast } from 'react-toastify';

const authReducer = (state = {}, action) => {
  switch (action.type) {
    case 'SIGN_IN':
      toast.info('Content de vous revoir...');
      return state;
    case 'SIGN_IN_ERR':
      toast.error("Erreur d'identification...");
      return state;
    case 'SIGN_OUT':
      toast.success('Déconnexion réussie.');
      return state;
    case 'SIGN_UP':
      toast.success('Bienvenue...');
      return state;
    case 'SIGN_UP_ERR':
      toast.error("Erreur d'inscription...");
      return state;
    case 'FORGET_PASSWORD':
      toast.success(
        `Consultez votre adresse e-mail pour récupérer votre mot de passe...`
      );
      return state;
    case 'FORGET_PASSWORD_ERR':
      toast.error('Aucun utilisateur ne correspond à cette adresse e-mail...');
      return state;
    default:
      return state;
  }
};

export default authReducer;
